export default "__VITE_ASSET__30_PPHne__"